import { useLazyFetch } from "hooks/fetch/useLazyFetch";

/**
 * Provides a callback function which can be used to post to the url passed in
 * @param url the url to post to
 * @param onCompleted callback that is fired when the post completes successfully
 * @param onError callback that is fired when the post errors
 * @returns {{loading: boolean, error: boolean, postCallback: ((function(*=, *=): void)|*)}}
 *
 * loading - true when post is currently happening.
 *
 * error - true when an error has occured.
 *
 * postCallback - the post callback function, takes a body object and returns an abort function and a response promise
 */
export function useFetchPost(
  url,
  onCompleted = undefined,
  onError = undefined
) {
  const { loading, error, fetchCallback } = useLazyFetch(
    url,
    "POST",
    onCompleted,
    onError
  );

  return { loading, error, postCallback: fetchCallback };
}
